/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useEffect, Fragment } from 'react';
import { BaseTemplate, Button, Card, Icons, PageState } from '@myob/myob-widgets';
import { useHistory } from 'react-router-dom';
import { ERoutePath } from 'router';
import { splitAccessTokeFromPath, trackClickInErrorPage, trackViewInErrorPage, isAccessTokenPath } from '../helper';
import NavigationBar from 'components/NavigationBar';
import { getFeatureToggle, ToggleNames } from 'helpers/featureToggle';

export type Props = {};

export const PageNotFound: React.FC<Props> = () => {
    const { push, location } = useHistory();
    const isAccessTokenExclude = getFeatureToggle(ToggleNames.FEATURE_AVOID_INVALID_ERROR_TRACK);
    const isAccessTokenLink = isAccessTokenExclude && isAccessTokenPath(location.pathname);
    const handleGoToMyAccount = () => {
        trackClickInErrorPage('home', 'PageNotFound');
        push(ERoutePath.Home);
    };
    useEffect(() => {
        if (!isAccessTokenLink) {
            trackViewInErrorPage('PageNotFound', splitAccessTokeFromPath(location.pathname));
        }
    }, [location.pathname, isAccessTokenLink]);

    return isAccessTokenLink ? null : (
        <Fragment>
            <NavigationBar />
            <BaseTemplate>
                <Card>
                    <PageState
                        title="Sorry, it looks like you've landed in the wrong place"
                        description="We can't load the page because it doesn't seem to exist."
                        actions={[
                            <Button
                                key="gotoMyAccount"
                                type="link"
                                icon={<Icons.ArrowRight />}
                                iconRight
                                onClick={handleGoToMyAccount}
                            >
                                Go to My Account instead
                            </Button>,
                        ]}
                        image={
                            <img
                                src="https://feelix-assets.s3-ap-southeast-2.amazonaws.com/page-state/empty-state/no-results-found.svg"
                                alt="no results found"
                            />
                        }
                    />
                </Card>
            </BaseTemplate>
        </Fragment>
    );
};

export default PageNotFound;
